import { Case, Switch } from 'react-if';
import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import { CountryCode } from '@zep/types';
import { Stack } from '@zep/ui';
import { OperationType } from '../../../../types';
import { fDateTimeByCountryCode } from '../../../../utils';
import { usePlanSpaceDetailContext } from '../plan';
import { PlanSpaceGroup, PlanSpacesSection } from '../space/organisms';
import S from './AppliedPlan.module.scss';
import { AppliedPlanList } from './AppliedPlanList';
import { CurrentPlanActive, ReadyPlanGroup } from './CurrentPlanActive';
import { CurrentPlanExpired } from './CurrentPlanExpired';
import { CurrentReady } from './CurrentPlanReady';
export const AppliedPlan = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    spacePlan,
    readySpacePlans,
    subscription,
    space
  } = usePlanSpaceDetailContext();
  return <PlanSpacesSection title={t('subscription:SpaceDetail.menuManage.titleAppliedPlan')} data-sentry-element="PlanSpacesSection" data-sentry-component="AppliedPlan" data-sentry-source-file="AppliedPlan.tsx">
      <Switch data-sentry-element="Switch" data-sentry-source-file="AppliedPlan.tsx">
        <Case condition={spacePlan?.status === 'EXPIRED'} data-sentry-element="Case" data-sentry-source-file="AppliedPlan.tsx">
          {readySpacePlans.length === 0 ? <CurrentPlanExpired /> : <>
              <ReadyPlanGroup readySpacePlans={readySpacePlans} countryCode={space?.countryCode} />
              <AppliedPlanList space={space} spacePlan={readySpacePlans[0].readySpacePlan} />
            </>}
        </Case>
        <Case condition={spacePlan?.status === 'ACTIVE'} data-sentry-element="Case" data-sentry-source-file="AppliedPlan.tsx">
          <CurrentPlanActive data-sentry-element="CurrentPlanActive" data-sentry-source-file="AppliedPlan.tsx" />
          <AppliedPlanList space={space} spacePlan={spacePlan} subscription={subscription} data-sentry-element="AppliedPlanList" data-sentry-source-file="AppliedPlan.tsx" />
          {(subscription?.requestedAction === 'UNSUBSCRIBE' || spacePlan?.operationType === OperationType.일시납 || spacePlan?.operationType === OperationType.커스텀_일시납) && <EndDate title={t('subscription:SpaceDetail.menuManage.enterPlanExpiredDate')} date={spacePlan?.endDate ?? ''} countryCode={space?.countryCode} />}
        </Case>
        <Case condition={!spacePlan && readySpacePlans.length} data-sentry-element="Case" data-sentry-source-file="AppliedPlan.tsx">
          <CurrentReady data-sentry-element="CurrentReady" data-sentry-source-file="AppliedPlan.tsx" />
          <AppliedPlanList space={space} spacePlan={readySpacePlans[0]?.readySpacePlan} data-sentry-element="AppliedPlanList" data-sentry-source-file="AppliedPlan.tsx" />
        </Case>
      </Switch>
    </PlanSpacesSection>;
};
export const EndDate = ({
  title,
  date,
  countryCode
}: {
  title: string;
  date: string;
  countryCode: CountryCode;
}) => {
  return <PlanSpaceGroup title={title} data-sentry-element="PlanSpaceGroup" data-sentry-component="EndDate" data-sentry-source-file="AppliedPlan.tsx">
      <Stack direction={'row'} gap={8} style={{
      alignItems: 'flex-end'
    }} data-sentry-element="Stack" data-sentry-source-file="AppliedPlan.tsx">
        <label className={cns(S.label, S.gray)}>
          {fDateTimeByCountryCode(date, countryCode)}
        </label>
      </Stack>
    </PlanSpaceGroup>;
};